import { appStringifySearch } from "@/core/lib/search-params";

/**
 * Href for a canonicalizing redirect inside a project subtree: swaps the
 * requested project id in the pathname for the canonical root id while
 * keeping the sub-path being navigated to: a typed `redirect({ to: ".../$id" })`
 * would land every deep navigation on the overview, and re-serializes the
 * full destination search with the given active entity.
 */
export function projectSubtreeHref(
  location: { pathname: string; search: Record<string, unknown> },
  rootId: string,
  requestedId: string,
  entityProjectId: string | undefined,
): string {
  return (
    location.pathname.replace(requestedId, rootId) +
    appStringifySearch({ ...location.search, entityProjectId })
  );
}
